import './App.css';
import DashBoard from './containers/DashBoard';
function App() {
  return (
    <div className="App">
      <DashBoard />
    </div>
  );
}

export default App;
